/* eslint-disable no-undef */
import React, { createContext, useState, useContext, useEffect } from "react";
import {
  DEFAULT_IFRAME_HEIGHT,
  DEFAULT_IFRAME_WIDTH,
  MOBILE_BREAKPOINT,
} from "../constants";
import { useConfig } from "./ConfigContext";

const ChatWindowContext = createContext();

export const ChatWindowProvider = ({ children }) => {
  const { setConfig } = useConfig();

  const [open, setOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [iframeSizes, setIframeSizes] = useState({});

  const toggleWindow = (isOpen) => {
    triggerResize(isOpen);
  };

  const triggerResize = (isOpen) => {
    if ("parentIFrame" in window) {
      parentIFrame.size(
        isOpen ? iframeSizes.height : 100,
        isOpen ? iframeSizes.width : 100
      );
    }
  };

  const handleToggleWidget = (open) => {
    setOpen(open);
    const widgetConfig = localStorage.getItem("webchat_config");
    localStorage.setItem(
      "webchat_config",
      widgetConfig
        ? JSON.stringify({ ...JSON.parse(widgetConfig), open })
        : JSON.stringify({ open })
    );
  };

  useEffect(() => {
    const messageHandler = (event) => {
      const prefix = "[iFrameSizer]message:";
      if (typeof event.data === "string" && event.data.startsWith(prefix)) {
        const jsonString = event.data.slice(prefix.length);
        try {
          const data = JSON.parse(jsonString);

          if (data === "iframeReady") {
            parentIFrame.getPageInfo((info) => {
              const viewportTall = info.clientHeight > DEFAULT_IFRAME_HEIGHT;
              const mobileWidth = info.clientWidth < MOBILE_BREAKPOINT;
              setIsReady(true);
              setIsMobile(mobileWidth);
              setIframeSizes({
                height:
                  viewportTall && !mobileWidth
                    ? DEFAULT_IFRAME_HEIGHT
                    : info.clientHeight,
                width: mobileWidth ? info.clientWidth : DEFAULT_IFRAME_WIDTH,
              });
            });
          }
          if (data.config) {
            const localMetadata = localStorage.getItem("webchat_meta");
            if (localMetadata) {
              setConfig({
                ...data.config,
                metadataOptions: JSON.parse(localMetadata),
              });
            } else {
              setConfig(data.config);
            }

            const localWidgetConfig = localStorage.getItem("webchat_config");
            if (localWidgetConfig) {
              const widgetConfig = JSON.parse(localWidgetConfig);
              setOpen(widgetConfig.open);
              triggerResize(widgetConfig.open);
            } else {
              triggerResize(false);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    };
    window.addEventListener("message", messageHandler);
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, []);

  return (
    <ChatWindowContext.Provider
      value={{
        open,
        setOpen: handleToggleWidget,
        isReady,
        setIsReady,
        isMobile,
        setIsMobile,
        iframeSizes,
        setIframeSizes,
        toggleWindow,
      }}
    >
      {children}
    </ChatWindowContext.Provider>
  );
};

export const useChatWindowSettings = () => {
  return useContext(ChatWindowContext);
};
